import { OrderResponse } from "@/types/external"
import { atom } from "jotai"

/**
 * Orders currently in progress (non-terminal). Populated by `useActiveOrders`.
 * Not persisted — refreshed on every app load via polling.
 */
export const activeOrdersAtom = atom<OrderResponse[]>([])

/**
 * Last few terminal orders (most recent first). Drives the horizontal
 * reorder section on the home screen, similar to iFood.
 */
export const recentOrdersAtom = atom<OrderResponse[]>([])
